import React, { useRef } from 'react';
import { Paper } from '@mui/material';
import SimpleContent from 'components/simpleContent';
import { getCardGridSpan } from 'constants/cardLayout';
import { getHighlightDimensions } from 'canvas/utils/autoLayout';

const ActivityGallery = ({
  activities,
  scrollRef,
  paperRefs,
  onPaperIndexChange,
  isBookmarkLayout = true,
  inverseZoom = 1,
  loadedTime,
  contentType = 'FEED',
}) => (
  <div className="library-feed-wrap">
    <div className="library-grid" ref={scrollRef}>
      {activities.map((activity, index) => (
        <Paper
          key={activity._id || activity.action?._id || `${activity.content?.[0]?._id || 'activity'}-${index}`}
          ref={el => {
            if (paperRefs?.current) paperRefs.current[index] = el;
          }}
          tabIndex={-1}
          className="library-card"
          style={{ gridColumn: `span ${getCardGridSpan(getHighlightDimensions(activity).elementWidth)}` }}
          onMouseEnter={() => onPaperIndexChange?.(index)}
        >
          {activity.content?.[0] ? (
            <SimpleContent
              type={contentType}
              isBookmarkLayout={isBookmarkLayout}
              activity={activity}
              inverseZoom={inverseZoom}
              loadedTime={loadedTime}
            />
          ) : null}
        </Paper>
      ))}
    </div>
  </div>
);

export default ActivityGallery;
